/* eslint-disable react/prop-types */
function BoxOneIcon({ className = "", width = "64px", height = "64px", fill = "#000000" }) {
  return (
    <svg
      className={className}
      fill={fill}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 450.001 450.001"
    >
      <g>
        <path d="M448.554,177.103c0,0-42.15-56.307-42.175-56.339c-0.011-0.015-0.93-1.647-3.762-2.548L226.973,68.62
            c-1.291-0.364-2.655-0.364-3.946,0L47.383,118.216c0,0-2.398,0.692-3.839,2.637c-0.577,0.779-42.097,56.25-42.097,56.25
            c-1.392,1.862-1.81,4.278-1.122,6.499c0.689,2.221,2.4,3.978,4.601,4.725l37.171,12.615v100.874c0,2.938,1.771,5.585,4.487,6.707
            l175.645,72.581c0.522,0.216,1.184,0.551,2.771,0.551s2.771-0.551,2.771-0.551l175.646-72.581c2.716-1.122,4.486-3.77,4.486-6.707
            V200.94l37.171-12.615c2.201-0.747,3.912-2.505,4.601-4.725C450.363,181.381,449.945,178.965,448.554,177.103z M19.062,177.794
            l33.138-44.28l13.403,3.692l75.431,20.778l71.335,19.652l-41.837,51.565L19.062,177.794z M217.743,363.542l-161.13-66.581v-91.094
            l114.04,38.708c0.764,0.261,1.551,0.384,2.332,0.384c2.145,0,4.231-0.953,5.635-2.686l39.124-48.219L217.743,363.542
            L217.743,363.542z M225,166.062L76.37,125.116L225,83.146l148.63,41.97L225,166.062z M393.388,296.961l-161.131,66.581V194.056
            l39.124,48.219c1.404,1.731,3.49,2.686,5.635,2.686c0.781,0,1.568-0.123,2.333-0.384l114.039-38.708V296.961L393.388,296.961z
            M279.469,229.203l-41.837-51.565l160.169-44.124l33.139,44.28L279.469,229.203z"/>
      </g>
    </svg>
  );
}

export default BoxOneIcon;
